import Link from 'next/link';

export const CustomerFooter = () => (
  <>
    <div className="mt-10">
      <h3 className="mb-4 footer-accordion-title">
        <a href="/equity-release" className="hover:underline">Equity Release</a>
      </h3>

      <ul className="space-y-3">
        <li>
          <Link
            href="/equity-release/what-is-equity-release"
            className="footer-accordion-content hover:underline"
          >
            What Is Equity Release?
          </Link>
        </li>
        <li>
          <Link
            href="/equity-release/how-does-equity-release-work"
            className="footer-accordion-content hover:underline"
          >
            How Does Equity Release work?
          </Link>
        </li>
        <li>
          <Link
            href="/equity-release/definitive-equity-release-glossary"
            className="footer-accordion-content hover:underline"
          >
            Definitive Equity Release Glossary
          </Link>
        </li>
      </ul>
    </div>

    <div className="mt-10">
      <h3 className="mb-4 footer-accordion-title">
        <a href="/knowledge-corner" className="hover:underline">Knowledge Corner</a>
      </h3>

      <ul className="space-y-3">
        <li>
          <Link
            href="/knowledge-corner/equity-release-faqs"
            className="footer-accordion-content hover:underline"
          >
            Your FAQs Answered
          </Link>
        </li>
        <li>
          <Link
            href="/knowledge-corner/what-is-compound-interest"
            className="footer-accordion-content hover:underline"
          >
            What is Compound interest?
          </Link>
        </li>
        <li>
          <Link
            href="/knowledge-corner/later-life-borrowing-and-you"
            className="footer-accordion-content hover:underline"
          >
            Later Life Borrowing and You
          </Link>
        </li>
      </ul>
    </div>

    <div className="mt-10">
      <h3 className="mb-4 footer-accordion-title">
        <a href="/existing-customers" className="hover:underline">Existing Customers</a>
      </h3>

      <ul className="mb-6">
        <li>
          <Link
            href="/existing-customers/existing-customers-faqs"
            className="footer-accordion-content hover:underline"
          >
            Existing Customers FAQs
          </Link>
        </li>
      </ul>

      <h3 className="mb-4 footer-accordion-title">
        <a href="/about-us" className="hover:underline">About Us</a>
      </h3>

      <ul className="space-y-3">
        <li>
          <Link
            href="/about-us/responsible-business"
            className="footer-accordion-content hover:underline"
          >
            Responsible Business
          </Link>
        </li>

        <li>
          <Link
            href="/careers"
            className="text-[#FFF] text-base font-semibold hover:underline"
          >
            Careers
          </Link>
        </li>
      </ul>
    </div>

    <div className="mt-10">
      <h3 className="mb-4 footer-accordion-title">
        <a href="https://customer.pureretirement.co.uk" className="hover:underline" rel="nofollow">MyPure Login</a>
      </h3>

      <ul>
        <li>
          <Link
            href="/contact-us"
            className="footer-accordion-content hover:underline"
          >
            Contact Us
          </Link>
        </li>
      </ul>

      <ul>
        <li className="flex items-center gap-4 mt-4">
          <Link href="https://www.youtube.com/@pureretirementforourcustom6170/videos">
            <img
              src="/img/icons/youtube-white.svg"
              alt="youtube"
              className="w-6 h-6"
            />
          </Link>
        </li>
      </ul>
    </div>
  </>
);
